<div [ngClass]="['toast-container', data.type]">
  <div class="toast-icon-wrap" aria-hidden="true">
    <mat-icon>{{ iconMap[data.type] }}</mat-icon>
  </div>
  <div class="toast-body">
    <div class="toast-title">{{ data.title }}</div>
    @if (data.message) {
    <div class="toast-message">{{ data.message }}</div>
    }
  </div>
  <button
    mat-icon-button
    class="close-btn"
    (click)="close()"
    aria-label="Dismiss notification"
  >
    <mat-icon>close</mat-icon>
  </button>
</div>
